<div class="main">
    <div *ngIf="showLoader" class="loader">
        <div class="load">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div class="section">
        <div class="title">
            Control Tower
        </div>
        <div class="">
            <div class="menu_sec">
                <div class="global">
                    <div class="header">
                        <nav class="nav" id="main-nav">
                            <div class="inner">
                                <ul>
                                    <li [ngClass]="{'active' : tabIndex==0}" (click)='switchTab(0)'><span>GPS &
                                            Vehicle</span></li>
                                    <li [ngClass]="{'active' : tabIndex==1}" (click)='switchTab(1)'>
                                        <span>In-Plant</span>
                                    </li>
                                    <li [ngClass]="{'active' : tabIndex==2}" (click)='switchTab(2)'>
                                        <span>En-Route</span>
                                    </li>
                                    <li *ngIf="!isJSPLRaigarh" [ngClass]="{'active' : tabIndex==3}" (click)='switchTab(3)'><span>Towards {{units}}</span></li>
                                    <li [ngClass]="{'active' : tabIndex==4}" (click)='switchTab(4)'>
                                        <span>Day Run</span>
                                    </li>
                                    <li [ngClass]="{'active' : tabIndex==5}" (click)='switchTab(5)'>
                                        <span>Sim Consent</span>
                                    </li>
                                </ul>
                                <span class="indicator"></span>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <div class="top_header">
            <div class="filters">
                <div class="input">
                    <input type="text" class="inputField" placeholder="From" (click)="fromDateInput1.open()"
                        [matDatepicker]="fromDateInput1" [(ngModel)]="fromDate" [min]="minDate" />
                    <mat-datepicker #fromDateInput1 (closed)="getDateRange()"></mat-datepicker>
                    <span class="material-icons dateIcon">
                        <img src="assets/calender-icon-modenik.svg" alt="Calender"> </span>
                </div>
                <div class="input">
                    <input type="text" class="inputField" placeholder="To" (click)="toDateInput1.open()"
                        [matDatepicker]="toDateInput1" [(ngModel)]="toDate" [min]="minDate" />
                    <mat-datepicker #toDateInput1 (closed)="getDateRange()"></mat-datepicker>
                    <span class="material-icons dateIcon">
                        <img src="assets/calender-icon-modenik.svg" alt="Calender"> </span>
                </div>
                <div>
                    <mat-select class="inputSelect" placeholder="Customer">
                        <mat-option>
                        </mat-option>
                    </mat-select>
                </div>
                <div>
                    <mat-select class="inputSelect" placeholder="Destination">
                        <mat-option>
                        </mat-option>
                    </mat-select>
                </div>
                <div>
                    <mat-select class="inputSelect" placeholder="Material">
                        <mat-option>
                        </mat-option>
                    </mat-select>
                </div>
                <div>
                    <mat-select class="inputSelect" placeholder="Carrier">
                        <mat-option>
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
        <div [hidden]="tabIndex!=0">
            <div class="gps_tracking_main">
                <div class="gps_tracking_sec">
                    <div class="header">
                        <div class="title_sec">
                            <div class="gps_title">
                                <div>
                                    <img src="assets/gps_tracking_new.svg" alt="">
                                </div>
                                <div class="label">
                                    GPS Tracking : {{totalGpsVehicles}}
                                </div>
                            </div>
                            <div class="refresh_icon">
                                <span (click)="getVehicleTrackingBreakup()" style="cursor: pointer;">
                                    <img src="assets/refresh-icon.svg" alt="">
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="tracking_main">
                    <div class="actively_tracking">
                        <div class="heading" >
                            <div style="color: #18BE8A;">Actively Tracking : {{trackingCount}}</div>
                            <div class="info_icon" (click)="toogleinfo('actively')"> <img src="assets/info-circle.svg" alt=""> 
                                <div *ngIf="activelyTrackingInfo" class="actively_tracking_info">
                                    <div class="info_header">
                                        <!-- <img class="info_close" src="assets/info_close_icon.svg" alt=""> -->
                                    </div>
                                    <div class="body">
                                        <span class="info_head">{{'VEHICLEREGISTRATION.running' | translate}} - </span>
                                        <span class="info_text">{{'VEHICLEREGISTRATION.running_text' | translate}}</span>
                                        <div style="margin-top: 6px;">
                                            <span class="info_head" style="color:#FFBC42;">{{'VEHICLEREGISTRATION.idle' |
                                                translate}} - </span>
                                            <span class="info_text">{{'VEHICLEREGISTRATION.idle_text' | translate}}</span>
                                        </div>
                                        <div style="margin-top: 6px;">
                                            <span class="info_head" style="color:#8B9FF2;">{{'VEHICLEREGISTRATION.parked' |
                                                translate}} - </span>
                                            <span class="info_text">{{'VEHICLEREGISTRATION.parked_text' | translate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cards_sec">
                            <div class="card" *ngFor="let item of tracking" (click)="showdGPSDetails({title: item.name, shipments: item.shipments})">
                                <div class="count">{{item.count}}</div>
                                <div class="status">{{item.name | titlecase}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="passively_tracking">
                        <div class="heading" style="color: #2962FF;">
                            <div>Passively Tracking : {{passivelyTrackingCount}}</div>
                            <div class="info_icon" (click)="toogleinfo('passivelytracking')"> <img src="assets/info-circle.svg" alt="">
                                <div *ngIf="passivelytrackingInfo" class="passively_tracking_info">
                                    <div class="info_header">
                                        <!-- <img class="info_close" src="assets/info_close_icon.svg" alt=""> -->
                                    </div>
                                    <div class="body">
                                        <span class="info_head" style="color: #EF99A7;">{{'VEHICLEREGISTRATION.irregular' |
                                            translate}} - </span>
                                        <span class="info_text">{{'VEHICLEREGISTRATION.irregular_text' | translate}}</span>
                                        <div style="margin-top: 6px;">
                                            <span class="info_head"
                                                style="color:#A1A2A7;">{{'VEHICLEREGISTRATION.temporary_offline' |
                                                translate}} - </span>
                                            <span class="info_text">{{'VEHICLEREGISTRATION.temporary_offline_text' |
                                                translate}}</span>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div class="cards_sec">
                            <div class="card" *ngFor="let item of nonTracking2" (click)="showdGPSDetails({title: item.name, shipments: item.shipments})">
                                <div class="count">{{item.count}}</div>
                                <div class="status">{{item.name | titlecase}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="non_tracking">
                        <div class="heading">
                           <div style="color: #E6667B;">Non Tracking : {{nonTrackingCount}}</div>
                           <div class="info_icon" (click)="toogleinfo('non_tracking')"> <img src="assets/info-circle.svg" alt="">
                            <div *ngIf="nontrackingInfo" class="non_tracking_info">
                                <div class="info_header">
                                    <!-- <img class="info_close" src="assets/info_close_icon.svg" alt=""> -->
                                </div>
                                <div class="body">
                                    <span class="info_head" style="color: #D67D92;">{{'VEHICLEREGISTRATION.offline' |
                                        translate}} - </span>
                                    <span class="info_text">{{'VEHICLEREGISTRATION.offline_text' | translate}}</span>
                                    <div style="margin-top: 6px;">
                                        <span class="info_head"
                                            style="color:#C69DD2;">{{'VEHICLEREGISTRATION.never_activated' | translate}}
                                            - </span>
                                        <span class="info_text">{{'VEHICLEREGISTRATION.never_activated_text' |
                                            translate}}</span>
                                    </div>
                                </div>
                            </div>
                            </div> 
                        </div>
                        <div class="cards_sec">
                            <div class="card" *ngFor="let item of nonTracking" (click)="showdGPSDetails({title: item.name, shipments: item.shipments})">
                                <div class="count">{{item.count}}</div>
                                <div class="status">{{item.name | titlecase}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="no_gps_installed">
                        <div class="heading" style="white-space: nowrap;color: #E6667B;">No GPS Installed : {{noGps.count}}</div>
                        <div class="cards_sec">
                            <div class="card" *ngFor="let item of nonData;" (click)="showdGPSDetails({title: item.name, shipments: item.shipments})">
                                <div class="count">{{item.count}}</div>
                                <div class="status">{{item.name | titlecase}}</div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <div class="vehicle_flow">
                <div class="header">
                    <div class="title_sec">
                        <div class="gps_title">
                            <div>
                                <img src="assets/vehicle_flow.svg" alt="">
                            </div>
                            <div class="label">
                                Vehicle Flow : {{vehicleFlowCount}}
                            </div>

                        </div>
                        <div class="refresh_icon">
                            <span (click)="getVehicleFlow()" style="cursor: pointer;">
                                <img src="assets/refresh-icon.svg" alt="">
                            </span>
                        </div>

                    </div>
                </div>
                <div class="cards_sec">
                    <div class="card" *ngFor="let vehicle of vehicleflow">
                        <div class="card_title">
                            {{vehicle.zone || 'Others'}}
                        </div>
                        <div class="card_body" (click)="showdDetails({title: vehicle.zone, shipments: vehicle.shipments});">
                            <div class="count_unit">
                                <div class="count">{{vehicle.total_weight.toFixed(0)}}</div>
                                <div class="unit">MT</div>
                            </div>
                            <div class="total">{{vehicle.vehicles}} Vehicles</div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="vehicles_Stage_wise_summary">
                <div class="header">
                    <div class="title_sec">
                        <div class="gps_title">

                            <div>
                                <img src="assets/vehicles_stage_wise.svg" alt="">
                            </div>
                            <div class="label">
                                Vehicle's Stage Wise Summary : {{vehicleStageCount}}
                            </div>
                        </div>
                        <div class="refresh_icon">
                            <span (click)="getVehicleStageWiseSummary()" style="cursor: pointer;">
                                <img src="assets/refresh-icon.svg" alt="">
                            </span>
                        </div>


                    </div>
                </div>
                <div class="cards_sec">
                    <div class="card"  *ngFor="let vehicleStage of vehicleStageWiseSummary">
                        <div class="card_title">
                            <!-- Waiting for DO -->
                            {{vehicleStage._id | titlecase}}
                        </div>
                        <div class="card_body"
                        (click)="showdDetails({title: vehicleStage._id, shipments: vehicleStage.shipments });">
                            <div class="count_unit">
                                <div class="count">{{vehicleStage.weight}}</div>
                                <div class="unit">MT</div>
                            </div>
                            <div class="total">{{vehicleStage.vehicles}} Vehicles</div>
                        </div>
                    </div>
                    <!-- <div class="card" >
                        <div class="card_title">
                            waiting_for_do
                            
                        </div>
                        <div class="card_body">
                            <div class="count_unit">
                                <div class="count">0</div>
                                <div class="unit">MT</div>
                            </div>
                            <div class="total">0 Vehicles</div>
                        </div>
                    </div> -->
                    <!-- <div class="card">
                        <div class="card_title">
                            DO Issued
                        </div>
                        <div class="card_body"
                            (click)="showdDetails({title: 'DO Issued', shipments: vehicleStage.do_issued_shipments});">
                            <div class="count_unit">
                                <div class="count">{{vehicleStage.do_issued_weight}}</div>
                                <div class="unit">MT</div>
                            </div>
                            <div class="total">{{vehicleStage.do_issued_count}} Vehicles</div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card_title">
                            PO-GI
                        </div>
                        <div class="card_body"
                            (click)="showdDetails({title: 'PO-GI', shipments: vehicleStage.po_gi_shipments});">
                            <div class="count_unit">
                                <div class="count">{{vehicleStage.po_gi_weight}}</div>
                                <div class="unit">MT</div>
                            </div>
                            <div class="total">{{vehicleStage.po_gi_count}} Vehicles</div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card_title">
                            In-Plant
                        </div>
                        <div class="card_body"
                            (click)="showdDetails({title: 'In-Plant', shipments: vehicleStage.in_plant_shipments});">
                            <div class="count_unit">
                                <div class="count">{{vehicleStage.in_plant_weight}}</div>
                                <div class="unit">MT</div>
                            </div>
                            <div class="total">{{vehicleStage.in_plant_count}} Vehicles</div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card_title">
                            Enroute
                        </div>
                        <div class="card_body"
                            (click)="showdDetails({title: 'Enroute', shipments: vehicleStage.enRoute_shipments});">
                            <div class="count_unit">
                                <div class="count">{{vehicleStage.enRoute_weight}}</div>
                                <div class="unit">MT</div>
                            </div>
                            <div class="total">{{vehicleStage.enRoute_count}} Vehicles</div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card_title">
                            At Customer Site
                        </div>
                        <div class="card_body"
                            (click)="showdDetails({title: 'At Customer Site', shipments: vehicleStage.at_customer_shipments});">
                            <div class="count_unit">
                                <div class="count">{{vehicleStage.at_customer_weight}}</div>
                                <div class="unit">MT</div>
                            </div>
                            <div class="total">{{vehicleStage.at_customer_count}} Vehicles</div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div [hidden]="tabIndex!=1">
            <div class="in_plant_main">
                <div class="in_plant">
                    <div class="in_plant_event_staging">
                        <div class="in_plant_event">
                            <div class="header">
                                <div class="title_sec">
                                    <div class="gps_title">

                                        <div>
                                            <img src="assets/inplant_event.svg" alt="">
                                        </div>
                                        <div class="label">
                                            In-Plant Event Staging : {{inPlantStageCount}}
                                        </div>
                                    </div>
                                    <div class="refresh_icon">
                                        <span (click)="getInplantStagging()" style="cursor: pointer;">
                                            <img src="assets/refresh-icon.svg" alt="">
                                        </span>
                                    </div>

                                </div>
                            </div>
                            <div class="cards_sec">

                                <div class="item" *ngFor="let inplant of inplantStagging">
                                    <div class="card_title">
                                        {{inplant._id.materials_name}}
                                    </div>
                                    <div class="card_body"
                                        (click)="showdInPlantDetails({ title: inplant._id.materials_name, shipments: inplant.shipments})">
                                        <div class="tat_hrs">
                                            <div class="hrs_count">{{getHoursandMinutes (inplant.avg_TAT * 60)}}</div>
                                            <div class="hrs">HH:MM</div>
                                        </div>
                                        <div class="weight">
                                            <div class="weight_count">{{inplant.total_weight.toFixed(0)}}</div>
                                            <div class="weight_text">MT</div>
                                        </div>
                                        <div class="total">{{inplant.no_of_trips}} Vehicles</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <div class="inplant_tat">
                    <div class="header">
                        <div class="title_sec">
                            <div class="gps_title">

                                <div>
                                    <img src="assets/inplant_tat.svg" alt="">
                                </div>
                                <div class="label">
                                    In-Plant TAT : {{inPlantTatCount}}
                                </div>
                            </div>
                            <div class="refresh_icon">
                                <span (click)="getHoursSlab()" style="cursor: pointer;">
                                    <img src="assets/refresh-icon.svg" alt="">
                                </span>
                            </div>


                        </div>
                    </div>
                    <div class="cards_sec">
                        <div class="card" *ngFor="let stagingHrs of stagingHrsSlab">
                            <div class="card_title"
                                [ngStyle]="{'color': stagingHrs._id.hour_slab === 'Greater than 10 Hrs' ? '#D60023' : '#42454E'}">
                                {{stagingHrs._id.hour_slab}}
                            </div>
                            <div class="card_body"
                                (click)="showdInTATPlantDetails({ title: stagingHrs._id.hour_slab, shipments: stagingHrs.res})">
                                <div class="count_unit">
                                    <div class="count">TOTAL -
                                        <span
                                            [ngStyle]="{'color': stagingHrs._id.hour_slab === 'Greater than 10 Hrs' ? '#D60023' : '#42454E'}">{{stagingHrs.total_no_of_trips}}</span>
                                    </div>

                                </div>
                                <div class="grid2x2">
                                    <div class="box box1" *ngFor="let mat of stagingHrs.res">
                                        <div>
                                            <span class="name">{{mat.materials_name.toString()}} -</span>
                                            <span class="count_text"
                                                [ngStyle]="{'color': stagingHrs._id.hour_slab === 'Greater than 10 Hrs' ? '#D60023' : '#42454E'}">{{mat.no_of_trips}}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div [hidden]="tabIndex!=2">
            <div class="en_route_main">
                <div class="in_plant">
                    <div class="in_plant_event_staging">
                        <div class="in_plant_event">
                            <div class="header">
                                <div class="title_sec">
                                    <div class="gps_title">
                                        <div>
                                            <img src="assets/enroute_eta.svg" alt="">
                                        </div>
                                        <div class="label">
                                            En-Route ETA Compliance : {{enrouteComplianceCount}}
                                        </div>
                                    </div>
                                    <div class="refresh_icon">
                                        <span (click)="getDelayedByDuration()" style="cursor: pointer;">
                                            <img src="assets/refresh-icon.svg" alt="">
                                        </span>
                                    </div>

                                </div>
                            </div>
                            <div class="cards_sec">
                                <div class="card" *ngFor="let delayedBy of delayedByDuration">
                                    <div class="card_title"
                                        [ngStyle]="{'color': delayedBy._id === 'Delayed By >24hrs' || delayedBy._id === 'Delayed By 24hrs' ? '#E6667B' : '#42454E'}">
                                        {{delayedBy._id}}
                                    </div>
                                    <div class="card_body"
                                        (click)="showEnrouteDetails({title: delayedBy._id, shipments: delayedBy.shipments})">
                                        <div class="count_unit">
                                            <div class="count"
                                                [ngStyle]="{'color': delayedBy._id === 'Delayed By >24hrs' || delayedBy._id === 'Delayed By 24hrs' ? '#E6667B' : '#42454E'}">
                                                {{delayedBy.vehicles}}</div>
                                            <div class="total">Vehicles</div>
                                        </div>

                                    </div>
                                </div>
                              
                            </div>
                        </div>
                    </div>

                </div>
                <div class="in_transit_by_weight">
                    <div class="in_plant_carrier">
                        <div class="header">
                            <div class="title_sec">
                                <div class="gps_title">

                                    <div>
                                        <img src="assets/enroute_carrier_view.svg" alt="">
                                    </div>
                                    <div class="label">
                                        En-Route Material View : {{enrouteCarrierCount}}
                                    </div>

                                </div>
                                <div class="refresh_icon">
                                    <span (click)="getIntransitByWeight()" style="cursor: pointer;">
                                        <img src="assets/refresh-icon.svg" alt="">
                                    </span>
                                </div>


                            </div>
                        </div>
                        <div class="cards_sec">
                            <div class="card" *ngFor="let intransitBy of intransitByWeight">
                                <div class="card_title">
                                    {{intransitBy._id.materials_name}}
                                </div>
                                <div class="card_body"
                                    (click)="showEnrouteDetails({title: intransitBy._id, shipments: intransitBy.shipments})">
                                    <div class="count_unit">
                                        <div class="count">{{intransitBy.total_weight.toFixed(0)}}</div>
                                        <div class="unit">MT</div>
                                    </div>
                                    <div class="total">{{intransitBy.no_of_trips}} Vehicles</div>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </div>
                <div class="enroute_delays">
                    <div class="vehicle_flow">
                        <div class="header">
                            <div class="title_sec">
                                <div class="gps_title">

                                    <div>
                                        <img src="assets/enroute_delays_halts_alerts.svg" alt="">
                                    </div>
                                    <div class="label">
                                        En-Route Delays and Halts Alerts : {{enrouteDelayCount}}
                                    </div>
                                </div>
                                <!-- Refresh icon -->
                                <div class="refresh_icon">
                                    <span (click)="getDelayByHaltDuration()" style="cursor: pointer;">
                                        <img src="assets/refresh-icon.svg" alt="">
                                    </span>
                                </div>
                                


                            </div>
                        </div>
                        <div class="cards_sec">
                            <div class="card" *ngFor="let delaysByHalt of delaysByHaltDuration">
                                <div class="card_title"
                                    [ngStyle]="{'color': delaysByHalt._id === '>48Hrs' ? '#E6667B' : '#42454E'}">
                                    {{delaysByHalt._id}}
                                </div>
                                <div class="card_body" (click)="showEnrouteDetails({title: delaysByHalt._id, shipments: delaysByHalt.shipments})">
                                    <div class="count_unit">
                                        <div class="count" [ngStyle]="{'color': delaysByHalt._id === '>48Hrs' ? '#E6667B' : '#42454E'}">{{delaysByHalt.vehicles}}</div>
                                        <div class="unit">Vehicles</div>
                                    </div>
                                </div>
                            </div>
                       
                        </div>
                    </div>
                </div>
                <div class="enroute_delays">
                    <div class="vehicle_flow">
                        <div class="header">
                            <div class="title_sec">
                                <div class="gps_title">
                                <div>
                                    <img src="assets/customer_detention.svg" alt="">
                                </div>
                                <div class="label">
                                    Customer Detention : {{customerDetentionCount}}
                                </div>
                            </div>
                            <div class="refresh_icon">
                                <span (click)="getCustomerDetention()" style="cursor: pointer;">
                                    <img src="assets/refresh-icon.svg" alt="">
                                </span>
                            </div>
                            </div>
                        </div>
                        <div class="cards_sec">
                            <div class="card" *ngFor="let customer of customerDetention">
                                <div class="card_title" [ngStyle]="{'color': customer._id.hour_slab === 'Greater than 48 Hrs' ? '#E6667B' : '#42454E'}">
                                   {{customer._id.hour_slab}}
                                </div>
                                <div class="card_body" (click)="showCustomerDetention({title: customer._id.hour_slab, shipments: customer.shipments})">
                                    <div class="count_unit">
                                        <div class="count" [ngStyle]="{'color': customer._id.hour_slab === 'Greater than 48 Hrs' ? '#E6667B' : '#42454E'}">{{customer.no_of_trips}}</div>
                                        <div class="unit"*ngIf="customer.no_of_trips > 1">Vehicles</div>
                                        <div class="unit" *ngIf="customer.no_of_trips==1">Vehicle</div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div [hidden]="tabIndex!=3">
            <div class="towards_angul_pickup">
                <div class="in_plant">
                    <div class="in_plant_event_staging">
                        <div class="in_plant_event">
                            <div class="header">
                                <div class="title_sec">
                                    <div>
                                        <img src="assets/towards_angul_pickup.svg" alt="">
                                    </div>
                                    <div class="label">
                                        Towards Angul Pickup: {{towardsAngulPickupCount}}
                                    </div>
                                </div>
                            </div>
                            <div class="cards_sec">
                                <div class="card" *ngFor="let towardsPickup of towardsPickupAngul">
                                    <div class="card_title">
                                        {{towardsPickup._id}}
                                    </div>
                                    <div class="card_body" (click)="showTowardsAngulDetails({title: towardsPickup._id, drivers: towardsPickup.drivers})">
                                        <div class="count_unit">
                                            <div class="count">{{towardsPickup.vehicles}}</div>
                                            <div class="total">Vehicles</div>
                                        </div>

                                    </div>
                                </div>
                              
                            </div>
                        </div>
                    </div>
                    <!-- <div class="in_plant_carrier_view">
                        <div class="in_plant_carrier">
                            <div class="header">
                                <div class="title_sec">
                                    <div>
                                        <img src="assets/jspl_helpline.svg" alt="">
                                    </div>
                                    <div class="label">
                                        JSPL Helpline
                                    </div>
                                </div>
                            </div>
                            <div class="cards_sec">
                                <div class="card">
                                    <div class="card_title">
                                    </div>
                                    <div class="card_body" style="display: flex;margin-top: 17px;">
                                        <div class="count_unit">

                                            <div>Plate</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card_title">
                                    </div>
                                    <div class="card_body" style="display: flex;margin-top: 17px;">
                                        <div class="count_unit">

                                            <div>TMT</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card_title">
                                    </div>
                                    <div class="card_body" style="display: flex;margin-top: 17px;">
                                        <div class="count_unit">

                                            <div>Semis</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div [hidden]="tabIndex !=4">
            <!-- <app-day-run></app-day-run> -->
        </div>
        <div [hidden]="tabIndex!=5">
            <app-sim-consent></app-sim-consent>
        </div>
    </div>
</div>